import { combineReducers } from 'redux';
import selectedEvents from '../components/Eventlist/reducer';
import filter from '../components/Actionbar/reducer';

export default combineReducers({
  selectedEvents,
  filter
});
